export default "__VITE_ASSET__fB9Ixj45__"